<template>
  <div v-if="modalVisible" class="dea-modal-overlay" :class="visibleClass">
    <div class="dea-modal">
      <div class="dea-modal__title-container">
        <div class="dea-modal__title">
          <h2 class="dea-modal__title-text">
            <div v-if="title" class="dea-modal--action__error-icon dea-ico-error"></div>
            <slot name="title">{{ title }}</slot>
          </h2>
        </div>
        <div class="dea-modal__close-button-container">
          <button class="dea-modal__close-button dea-ico-close" @click.stop="hide"></button>
        </div>
      </div>
      <div class="dea-modal__content">
        <slot name="content">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-if="content" class="dea-heading--regular__m" v-html="content"></div>
          <div v-else class="dea-heading--regular__m">
            Si è verificato un errore,
            <a href="javascript:location.reload()">aggiorna la pagina</a> o
            <a target="_blank" :href="config.contacts_url">contattaci</a>
          </div>
        </slot>
      </div>
      <div class="dea-modal__footer">
        <slot name="footer">
          <div v-if="code" class="dea-heading--regular__xxs">Code: {{ code }}</div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ModalAlert",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
    container: {
      type: String,
      default: ".main-content",
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      modalVisible: this.visible,
    };
  },
  computed: {
    visibleClass() {
      return this.modalVisible ? "dea-modal-overlay--visible" : "";
    },
  },
  methods: {
    hide() {
      this.modalVisible = false;
      this.$nextTick(() => {
        this.$destroy();
      });
    },
    show() {
      this.modalVisible = true;
    },
    setup(component, title, content, code, container, config) {
      const ComponentClass = Vue.extend(component);
      const codeStr = code ? code.join(" - ") : "";
      // eslint-disable-next-line no-param-reassign
      if (!container) container = ".main-content";
      const props = {};
      if (content) props.content = content;
      if (title) props.title = title;
      if (codeStr) props.code = codeStr;
      if (container) props.container = container;
      if (config) props.config = config;
      const instance = new ComponentClass({
        propsData: props,
      });
      instance.$mount();
      document.querySelector(container).appendChild(instance.$el);
      instance.show();
      return instance;
    },
    getErrorObject(e) {
      const error = {
        msg: "",
        codes: [],
      };
      if (e && e.response) {
        try {
          if (e.response.data.error) error.msg = e.response.data.error;
          if (e.response.data.codes) error.codes = e.response.data.codes;
        } catch {
          error.msg = e.response.data;
        }
      } else if (e && e.toString().indexOf("Network") === -1) {
        error.msg = e.toString();
      }
      return error;
    },
    handleException(ComponentClass, config, e, title) {
      const error = this.getErrorObject(e);
      return this.setup(ComponentClass, title, error.msg, error.codes, null, config);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

.dea-modal {
  background-color: $dea-color-white;

  &-overlay {
    background: rgba(0, 0, 0, 0.4);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10000;
  }

  &__title {
    &-text {
      align-items: center;
      display: flex;

      .dea-modal--action__error-icon {
        margin-bottom: 0;
        margin-right: $space-small;
      }
    }
  }

  &-buttons {
    display: flex;
    justify-content: space-between;
    margin: $space-base 0;
  }

  &-section {
    flex-grow: 1;
    padding: 0 $space-small;

    &__image {
      max-width: 100%;
    }
  }

  &__content {
    margin-bottom: $space-base;

    /deep/ a {
      border-bottom: $border-bold $dea-color-target-magenta-formazione;

      &:hover {
        opacity: 0.5;
      }
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;

    > * {
      margin: 0 $space-base;

      &:first-of-type {
        margin-left: 0;
      }

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
